"use strict";


angular.module("vendor")
.controller("InvoiceAttachmentController", function(
    $scope, $stateParams, bowser, InvoiceAttachmentService
) {
    $scope.invoice =  InvoiceAttachmentService.get($stateParams.id);
    $scope.showDownload = !bowser.msie;

    this.onDownload = function (image) {
        InvoiceAttachmentService.downloadImageAttachment(image.id);
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/invoice-attachment/invoice-attachment.controller.js
// module id = 990
// module chunks = 0